import React from 'react'
import { useState } from 'react';
import css from './PlantListPage.module.scss'
import plants from './plants.json';
import { NavLink, useNavigate } from "react-router-dom";
import CoachMarkStep1 from '../../Components/CoachMark/Step1';
import { useSelector } from 'react-redux'

const PlantListPage = () => {
  const navigate = useNavigate();
  
  const coachmark = localStorage.getItem("coachmark");
  const station = JSON.parse(localStorage.getItem('station'));
  // const data = station.filter(stat => stat.station_code === 'NE=51496542');
  const step = useSelector(state => state.Step)
  const [selectedPlant, setSelectedPlant] = useState(station[0].station_code);

  const handlePlantSelection = (plantId) => {
    setSelectedPlant(plantId);
  };
  
  const changeDataPlan = () => {
    localStorage.setItem("station_get", btoa(selectedPlant));
    // alert(btoa(selectedPlant))
    navigate("/home");
  };
  

  return (
  <div>
    <div style={{position:'relative'}}>
    {(step.coachmark == 1 && coachmark == 'false') && <CoachMarkStep1 />}
    <div className='container'>
      <div className='row'>
        <div className='col-md-12 text-center'>
          <div className={css.title}>
            Choose Plant Management 
          </div>
        </div>
      </div>
    </div>
    <div style={{ height: '70vh', overflowY: 'scroll', marginLeft: 20, marginTop: 20, paddingBottom:30, marginBottom:10 }}>
        {station.map((plant, i) => (
          <div key={`plants-${i}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 10 }}>
            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', width:'100%' }}>
              <div style={{ width: 44, marginLeft: 4 }}>
                <input className="form-check-input" type="radio" value={`${plant.id}`} name="plant" id={`check-${plant.id}`} style={{ borderColor: '#E0E3E9' }} checked={selectedPlant === `${plant.station_code}`} onChange={() => handlePlantSelection(`${plant.id}`)} />
              </div>
              <div onClick={() => handlePlantSelection(`${plant.station_code}`)} style={{width:'85%'}}>
                <div style={{ fontSize: 14, fontWeight: 500, color: '#393D45', display: 'flex', justifyContent: 'space-between' }}>
                  <span>{plant.station_name}</span>
                  <div style={{
                    width: 50, height: 20, background: plant.status === 'offline' ? '#FFEFEC' : '#E5F6E5',
                    color: plant.status === 'offline' ? '#FF1D19' : '#3B9D3F', borderRadius: 8, display: 'flex', justifyContent: 'center',
                    alignItems: 'center', fontSize: 10, fontWeight: 700
                  }}>{plant.status === 'offline' ? 'Faulty' : 'Normal'}</div>
                </div>
                <div style={{ fontSize: 12, fontWeight: 400, color: '#8F8F8F' }}>{plant.station_address}</div>
                {/* <div style={{ display: 'flex', alignItems: 'center', fontSize: 10, fontWeight: 500, marginTop: 6, marginBottom: 6, color: plant.status === 'Faulty' ? '#FF1D19' : '#8F8F8F' }}>
                  <img src={plant.status === 'Faulty' ? pv_faulty : pv_normal} alt="" style={{ marginRight: 4 }} />
                  <span>PV</span>
                  <img src={plant.status === 'Faulty' ? grid_faulty : grid_normal} alt="" style={{ marginLeft: 10, marginRight: 4 }} />
                  <span>GRID</span>
                  <img src={plant.status === 'Faulty' ? battery_faulty : battery_normal} alt="" style={{ marginLeft: 10, marginRight: 4 }} />
                  <span>BATTERY</span>
                </div> */}
              </div>
            </div>
            {plants.length - 1 !== i && <div style={{ height: 1, width: '100%', background: '#dedede', marginTop: 12, marginBottom: 12 }}></div>}
          </div>
        ))}
      </div>
      <div style={{
          height: 44, marginTop: 20, borderRadius: 8, background: '#2DFBB5', display: 'flex', justifyContent: 'center', alignItems: 'center',
          fontSize: 16, fontWeight: 700, color: '#292929', cursor: 'pointer', margin:20
        }} onClick={changeDataPlan} >
          Change Plant
      </div>
    </div>
  </div>
  )
}

export default PlantListPage